export default function elementsOffset(el): { top: number; left: number } {
    const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const rect = el.getBoundingClientRect();

    return { top: rect.top + scrollTop, left: rect.left + scrollLeft };
}
